module.exports = __webpack_public_path__ + "img/table4.50ca7fa3.png";